// extracted by mini-css-extract-plugin
module.exports = {"firstSeriesInApp":"FirstSeriesInApp_firstSeriesInApp__lr1rY"};